(function() {
  var Client, Session, Stats, errors, uniqueId,
    slice = [].slice;

  errors = require("./util/errors");

  uniqueId = require("./util/uniqueid");

  Client = require("./client");

  Session = (require("./session")).Session;


  /**
   * Helper class to wrap calls to the Doofinder stats API endpoint.
   */

  Stats = (function() {

    /**
     * Stats client constructor.
     * @param  {Client}   @client  Doofinder's Client instance
     * @param  {Session}  @session Session instance
     */
    function Stats(client) {
      this.client = client;
      if (!(this.client instanceof Client)) {
        throw errors.error("First parameter must be a Client object!", this);
      }
    }


    /**
     * Wrapper of @client.stats function.
     *
     * WARNING: This should be called ONLY if the user has performed a search.
     *          That's why this is usually called when the user has stopped
     *          typing in the search box.
     *
     * @param  {String}   sessionId Session id.
     * @param  {Function} callback  Optional callback to be called when the
     *                              response is received. First param is the
     *                              error, if any, and the second one is the
     *                              response, if any.
     * @public
     */

    Stats.prototype.registerSession = function(sessionId, callback) {
      return this.client.stats("init", {
        session_id: sessionId
      }, function(err, res) {
        return typeof callback === "function" ? callback(err, res) : void 0;
      });
    };


    /**
     * Registers a click on a search result for the specified search query.
     *
     * stats = new doofinder.Stats(client);
     * stats.registerClick(sessionId, id, datatype, query, callback);
     * stats.registerClick(sessionId, dfid, query, callback);
     *
     * @param  {String}   sessionId Session id.
     * @param  {String}   id        Id of the result or Doofinder's internal ID
     *                              for the result.
     * @param  {String}   datatype  Optional. If the id is not a Doofinder id
     *                              this argument is required.
     * @param  {String}   query     Optional. Search terms.
     * @param  {String}   custom_results_id Optional. Id of the custom results
     *                                      that produced the current set of
     *                                      results, including the current one
     *                                      being clicked.
     * @param  {Function} callback  Optional callback to be called when the
     *                              response is received. First param is the
     *                              error, if any, and the second one is the
     *                              response, if any.
     * @public
     */

    Stats.prototype.registerClick = function() {
      var args, callback, i, j, key, keys, len, len1, params, required, sessionId;
      sessionId = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
      errors.requireVal(sessionId, "sessionId");
      if (args.length === 0) {
        errors.requireVal(null, "dfid or (id + datatype)");
      } else if (uniqueId.dfid.isValid(args[0])) {
        required = ['dfid'];
      } else {
        required = ['id', 'datatype'];
      }
      keys = required.concat(['query']);
      params = {
        session_id: sessionId
      };
      for (i = 0, len = keys.length; i < len; i++) {
        key = keys[i];
        params[key] = args.shift();
      }
      if (params.query == null) {
        params.query = "";
      }
      for (j = 0, len1 = required.length; j < len1; j++) {
        key = required[j];
        errors.requireVal(params[key], key);
      }
      if (typeof args[0] !== "function") {
        params['custom_results_id'] = args.shift();
      }
      callback = args.shift();
      return this.client.stats("click", params, function(err, res) {
        return typeof callback === "function" ? callback(err, res) : void 0;
      });
    };


    /**
     * Registers a checkout.
     *
     * @param  {String}   sessionId Session id.
     * @param  {Function} callback  Optional callback to be called when the
     *                              response is received. First param is the
     *                              error, if any, and the second one is the
     *                              response, if any.
     * @public
     */

    Stats.prototype.registerCheckout = function(sessionId, callback) {
      errors.requireVal(sessionId, "sessionId");
      return this.client.stats("checkout", {
        session_id: sessionId
      }, function(err, res) {
        return typeof callback === "function" ? callback(err, res) : void 0;
      });
    };


    /**
     * Registers an event for a banner
     * @param  {String}   eventName Name of the event.
     *                              - display
     *                              - click
     * @param  {Number}   bannerId  Id of the banner.
     * @param  {Function} callback  Optional callback to be called when the
     *                              response is received. First param is the
     *                              error, if any, and the second one is the
     *                              response, if any.
     * @return {undefined}
     * @public
     */

    Stats.prototype.registerBannerEvent = function(eventName, bannerId, callback) {
      errors.requireVal(eventName, "eventName");
      errors.requireVal(bannerId, "bannerId");
      return this.client.stats("img_" + eventName, {
        img_id: bannerId
      }, function(err, res) {
        return typeof callback === "function" ? callback(err, res) : void 0;
      });
    };


    /**
     * Adds an amount of item in the current session cart
     * @param  {String}   sessionId   Session id.
     * @param  {String}   itemId      The item ID to add to the cart.
     * @param  {String}   amount      The amount of the item to be added.
     * @param  {Dict}     extraData   Optional arguments we want to provide of ["datatype", "title", "price"]
     *                                "datatype" defaults to "product"
     * @param  {Function} callback    Optional callback to be called when the
     *                                response is received. First param is the
     *                                error, if any, and the second one is the
     *                                response, if any.
     * @public
     */

    Stats.prototype.addToCart = function(sessionId, itemId, amount, extraData, callback) {
      var params;
      errors.requireVal(sessionId, "sessionId");
      errors.requireVal(itemId, "itemId");
      errors.requireVal(amount, "amount");
      params = {
        session_id: sessionId,
        item_id: itemId,
        amount: amount,
        datatype: extraData["datatype"] || "product",
        title: extraData["title"],
        price: extraData["price"]
      };
      return this.client.stats("add-to-cart", params, function(err, res) {
        return typeof callback === "function" ? callback(err, res) : void 0;
      });
    };


    /**
     * Removes an amount of item in the current session cart
     * @param  {String}   sessionId Session id.
     * @param  {String}   itemId    The item ID to add to the cart.
     * @param  {String}   amount    The amount of the item to be removed.
     * @param  {String}   datatype  (Default: product) The datatype of the
     *                              item we are adding
     * @param  {Function} callback  Optional callback to be called when the
     *                              response is received. First param is the
     *                              error, if any, and the second one is the
     *                              response, if any.
     * @public
     */

    Stats.prototype.removeFromCart = function(sessionId, itemId, amount, datatype, callback) {
      var params;
      if (datatype == null) {
        datatype = "product";
      }
      errors.requireVal(sessionId, "sessionId");
      errors.requireVal(itemId, "itemId");
      errors.requireVal(amount, "amount");
      params = {
        session_id: sessionId,
        item_id: itemId,
        amount: amount,
        datatype: datatype
      };
      return this.client.stats("remove-from-cart", params, function(err, res) {
        return typeof callback === "function" ? callback(err, res) : void 0;
      });
    };


    /**
     * Clears a cart from the current session, removing it all
     * @param  {String}   sessionId Session id.
     * @param  {Function} callback  Optional callback to be called when the
     *                              response is received. First param is the
     *                              error, if any, and the second one is the
     *                              response, if any.
     * @public
     */

    Stats.prototype.clearCart = function(sessionId, callback) {
      errors.requireVal(sessionId, "sessionId");
      return this.client.stats("clear-cart", {
        session_id: sessionId
      }, function(err, res) {
        return typeof callback === "function" ? callback(err, res) : void 0;
      });
    };

    return Stats;

  })();

  module.exports = Stats;

}).call(this);
